import { FormattedMessage } from 'react-intl';
import { InquiryOfferState } from '@synergy/models';
import { PoolSelect, useFilter } from '@synergy/components';
import { ReactNode } from 'react';
import { getDocumentStatusTranslationId } from '@synergy/utils';

export interface StatusFilterProps {
    inquiryOfferStates?: InquiryOfferState[];
}

export const InquiryOfferStateFilter = (props: StatusFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (status?: InquiryOfferState) => {
        filter.delete('inquiryOfferStates');
        if (status) {
            filter.set('inquiryOfferStates', status);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (statusValue: unknown): ReactNode => {
        if (typeof statusValue !== 'string') {
            return '';
        }

        const status = statusValue as InquiryOfferState;
        return <FormattedMessage id={getDocumentStatusTranslationId(status)} />;
    };

    registerFilterMap('inquiryOfferStates', getDisplayValue);

    const selectableStatus = props.inquiryOfferStates ?? Object.values(InquiryOfferState);

    return (
        <PoolSelect
            displayEmpty={true}
            name="inquiryOfferStates"
            label={<FormattedMessage id="app.filter.statusLabel" />}
            fullWidth={true}
            value={filter.get('inquiryOfferStates')}
            onValueChange={onSelected}
            noSorting={true}
            options={selectableStatus.map(status => {
                return {
                    value: status,
                    displayValue: <FormattedMessage id={getDocumentStatusTranslationId(status)} />,
                };
            })}
        />
    );
};
